import { gql } from '@apollo/client';

const APPLY_SHORT_CYCLE = gql`
  mutation ApplyShortCycle($accountId: String!) {
    applyShortCycleAssignment(accountId: $accountId)
  }
`;

const UPDATE_BILLING_CYCLE = gql`
  mutation UpdateBillingCycle($accountId: String!, $newBillingCycleDay: Int!) {
    updateBillingCycle(
      accountId: $accountId
      newBillingCycleDay: $newBillingCycleDay
    )
  }
`;

export { APPLY_SHORT_CYCLE, UPDATE_BILLING_CYCLE };
